import React from 'react';

import './index.scss';

import iconClose from '../../../../../../../assets/images/icon_fechar_x.svg';

const TagOption = ({ tag, onClickTagOption, add }) => {
  const { _id, botId, name, active, type } = tag;
  const tagAction = !!add ? 'add' : 'remove';

  return (
    <div className="select-line" onClick={() => onClickTagOption(tag) || false}>
      <label>{name}</label>
      <label id={`action-label-${tagAction}`}>
        <img src={iconClose} alt="Close" />
      </label>
    </div>
  );
};

export default TagOption;
